<template>
    <div class="form-group">
        <label :for="id" class="d-block form-label" v-if="label">
            {{label}}
            <i @click="$emit('info-click')" v-if="showInfo" class="info-icon"/>
        </label>
        <slot name="between"></slot>
        <div :class="append?'input-group':''">
            <input :type="type || 'text'" :id="id" class="form-control"
                   ref="input"
                   @input="$emit('input', $event.target)"
                   :placeholder="placeholder"
                   :value="value">
            <div class="input-group-append" v-if="append">
                <span class="input-group-text" v-text="append"/>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        mounted(){
            if (this.focus){
                this.$refs.input.focus()
            }
        },
        props: [
            'value', 'append', 'label', 'showInfo', 'type', 'placeholder', 'id', 'focus'
        ],
    }
</script>

<style lang="scss" scoped>
    .form-label {
        font-weight: bold;
        color: #000;
    }

    .form-control {
        border: 2px solid #DFDFDF;
        text-align: left;

        &:focus {
            border-color: #DFDFDF;
        }
    }

    .input-group {
        .form-control {
            text-align: left;
        }

        .input-group-text {
            border: 2px solid #DFDFDF;
            box-sizing: border-box;
            border-left: none;
            background: #fff;
            font-weight: bold;
            height: 38px;
            cursor: default;
            color: #000;
        }
    }

    .info-icon {
        background: url("../assets/icons/info-icon.svg") no-repeat;
        width: 24px;
        height: 18px;
        display: inline-block;
        margin-left: 10px;
        cursor: pointer;
        top: 3px;
        position: relative;
    }
</style>